import {
    RotateCcw,
    IndianRupee,
    User,
    Calendar,
    FileText,
    BadgeCheck,
} from "lucide-react";

import "./RefundTab.css";

function RefundTab({ order }) {

    const refund = order.refund || {};

    return (

        <div className="refund-tab">

            <div className="refund-header">

                <h2>Refund Information</h2>

                <p>

                    Refund processing details for this order.

                </p>

            </div>

            <div className="refund-grid">

                <div className="refund-item">

                    <RotateCcw size={22} />

                    <div>

                        <label>Status</label>

                        <h4>

                            {refund.status || "Not Initiated"}

                        </h4>

                    </div>

                </div>

                <div className="refund-item">

                    <IndianRupee size={22} />

                    <div>

                        <label>Refund Amount</label>

                        <h4>

                            ₹{refund.amount || 0}

                        </h4>

                    </div>

                </div>

                <div className="refund-item">

                    <User size={22} />

                    <div>

                        <label>Processed By</label>

                        <h4>

                            {refund.processedBy || "-"}

                        </h4>

                    </div>

                </div>

                <div className="refund-item">

                    <Calendar size={22} />

                    <div>

                        <label>Refund Date</label>

                        <h4>

                            {refund.refundedAt
                                ? new Date(refund.refundedAt).toLocaleString()
                                : "-"}

                        </h4>

                    </div>

                </div>

                <div className="refund-item">

                    <BadgeCheck size={22} />

                    <div>

                        <label>Transaction ID</label>

                        <h4>

                            {refund.transactionId || "-"}

                        </h4>

                    </div>

                </div>

                <div className="refund-item">

                    <FileText size={22} />

                    <div>

                        <label>Reason</label>

                        <h4>

                            {refund.reason || "-"}

                        </h4>

                    </div>

                </div>

            </div>

            <div className="refund-notes">

                <h3>Admin Notes</h3>

                <p>

                    {refund.notes || "No refund notes available."}

                </p>

            </div>

        </div>

    );

}

export default RefundTab;